import { render } from "./CustEmrPgCalculator.vue?vue&type=template&id=5ad401a2"
import script from "./CustEmrPgCalculator.vue?vue&type=script&lang=js"
export * from "./CustEmrPgCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__